<template>
  <div class="container container_01">
    <template v-if="(!isPage('todo'))&&(!isPage('doing'))&&(!isPage('done'))&&(!isPage('flow_cc'))">
      <div class="header-top"
           v-if="(!isPage('todo')||!isPage('doing')||!isPage('done')||!isPage('flow_cc'))&&!isPage('detail')">
        <ul class="img-ul-tip" v-if="isPage('apps')">
          <router-link :to="'/workflow/servicecenter?from=other'" tag="li">服务中心</router-link>
          <router-link :to="'/workflow/todo'" tag="li">待办事项
            <span class="nums">
              <el-badge v-if="todoLength > 0" class="mark" :value="todoLength"/>
            </span>
          </router-link>
        </ul>
        <template v-if="isPage('apps')">
          <template v-if="!logoError && EnterpriseId">
            <img class="bgcImg" :src="logoUrl" @error="()=>{ logoError = true }" alt=""/>
          </template>
          <template v-else>
            <img class="bgcImg" src="@/assets/images/banner-index.jpg" alt="">
          </template>
        </template>
        <a-row class="header-child" :class="isPage('apps')?'':'header-child-addstyle'">
          <a-col :span="2" style="line-height: 32px;font-size: 16px;color: white;" v-if="isPage('zt')">
            <router-link style="color: white" :to="'/workflow/index'">
              <i class="el-icon-arrow-left"></i>
            </router-link>
          </a-col>
          <a-col :span="20" style="line-height: 32px;font-size: 16px;color: white;" v-if="isPage('zt')">专题详情</a-col>
          <a-col :span="2" style="line-height: 32px;font-size: 16px;color: white;" v-if="isPage('zt')"></a-col>
          <a-col :span="1"/>
          <!--       图标 -->
          <a-col :span="2"
                 v-if="isPage('appall')||isPage('serviceC')||isPage('inventory')||isPage('favorite')||isPage('guide')||isPage('todo')||isPage('doing')||isPage('done')||isPage('flow_cc')">
            <router-link :to="'/workflow/index'">
              <a-icon type="left" class="leftIcon"/>
            </router-link>
          </a-col>
          <!--     搜索栏 位置内容  -->
          <a-col
              :span="( isPage('appall')||isPage('serviceC')||isPage('inventory')||isPage('favorite')||isPage('guide'))? 19 : isPage('apps')||isPage('todo')||isPage('doing')||isPage('done')||isPage('flow_cc')? 17 : 22">
            <a-input v-if="isPage('apps')" :class="isPage('apps')?'none_bgc':''" v-model="searchKeyword"
                     placeholder="搜索您要找的事宜" allowClear
                     @blur="onSearch" @keyup.enter.native="onSearch">
              <a-icon slot="prefix" type="search"/>
            </a-input>
            <a-input v-if="isPage('serviceC')" v-model="searchValue"
                     placeholder="搜索" allowClear
                     @blur="toSearch(searchValue)" @pressEnter='toSearch(searchValue)' @change="toSearch(searchValue)">
              <a-icon slot="prefix" type="search"/>
            </a-input>
            <span v-if="isPage('inventory')" style="font-size: 22px;color: white;line-height: 32px">清 单</span>
            <a-input v-if="isPage('todo')||isPage('doing')||isPage('done')||isPage('flow_cc')"
                     placeholder="搜索您要办理的事项名称" allowClear
                     @blur="" @pressEnter='' @change="">
              <a-icon slot="prefix" type="search"/>
            </a-input>
            <span v-if="isPage('favorite')" style="font-size: 22px;color: white;line-height: 32px">收藏夹</span>
            <span v-if="isPage('guide')" style="font-size: 22px;color: white;line-height: 32px">办事指南</span>
          </a-col>
          <a-col :span="3" v-if="isPage('todo')||isPage('doing')||isPage('done')||isPage('flow_cc')">
            <router-link style="line-height: 32px;font-size: 12px;color: white;margin-left: 4px"
                         :to="'/workflow/favorite'">
              收藏夹
            </router-link>
          </a-col>
          <a-col :span="1" v-if="isPage('inventory')">
          </a-col>
          <a-col :span="6" v-if="isPage('apps')">
        <span class="userName">{{ userName }}，您好！
        </span>
          </a-col>

          <a-col v-if="!isPage('apps')" :span="1"/>
        </a-row>
        <a-row class="header-chil" :class="isPage('apps')?'':'header-child-addstyle'">
          <ul style="height: 72px" class="nav"
              v-if="isPage('todo')||isPage('doing')||isPage('done')||isPage('flow_cc')">
            <li v-for="item in topTip" :key="item.id" v-if="item.isShow">
              <router-link :to="`${item.path}`">
                <img style="width: 32px;margin-bottom: 6px"
                     :src="isPage('apps') && item.img_type1?item.img_type1:item.img_type" alt="">
                <p :class=" item.path == $route.path? 'active' : ''" class="title">
                  {{ isPage('apps') ? item.title : item.title.slice(0, item.title.length - 2) }}</p>
                <span class="nums" :style="{right:isPage('apps')?'25px':'10px'}">{{ item.length }}</span>
              </router-link>
            </li>
          </ul>
        </a-row>
      </div>
    </template>
    <ul class="common_nav">
      <li :class="$route.name=='apps'?'activee':''">
        <router-link :to="'/workflow/index'" tag="a">
          <a-icon type="home" class="iconStyle" active-class="activee"/>
          首页
        </router-link>
      </li>
      <li :class="$route.name=='serviceC'?'activee':''">
        <router-link to="/workflow/servicecenter?from=other" tag="a" active-class="activee">
          <a-icon type="file-done" class="iconStyle"/>
          服务中心
        </router-link>
      </li>
      <li :class="$route.name=='inventory'?'activee':''">
        <router-link to="/workflow/inventory" tag="a" active-class="activee">
          <a-icon type="audit" class="iconStyle"/>
          服务清单
        </router-link>
      </li>
      <li :class="routeName() == 'todo'||routeName() == 'doing'||routeName() == 'done'||routeName() == 'flow_cc'?'activee':''">
        <router-link to="/workflow/todo" tag="a"
        >
          <a-icon type="user" class="iconStyle"/>
          个人中心
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  inject: ['isPage', 'reload', 'getSeconds', 'routeName', 'initData',
    'getDataSource',
    'getSeconds',
    'getLastTime',
    'getDays'],
  data() {
    return {
      imgName: 'index',
      logoUrl: '',
      logoError: false,
      searchValue: '',
      searchKeyword: '',
      visi_date: false,
      nowChooseYear: new Date().getFullYear(),
      aaa: require('@/assets/images/bannerImage.jpg'),
      topTip: [
        {
          id: Math.random() * 11,
          title: ' 待办事宜  ',
          path: '/workflow/todo',
          img_type: require('@/assets/todoCenter/default/images/dbsx.png'),
          isShow: true,
          length: 0,
          flag: 'todo'
        }, {
          id: Math.random() * 22,
          title: ' 进行中  ',
          path: '/workflow/doing',
          img_type: require('@/assets/todoCenter/default/images/jxzsx.png'),
          img_type1: require('@/assets/todoCenter/default/images/jxzsx1.png'),
          isShow: true,
          length: 0,
          flag: 'doing'
        }, {
          id: Math.random() * 44,
          title: ' 已完成  ',
          path: '/workflow/done',
          img_type: require('@/assets/todoCenter/default/images/ywcsx.png'),
          isShow: true,
          length: 0,
          flag: 'done'
        }, {
          id: Math.random() * 33,
          title: ' 抄送   ',
          path: '/workflow/flow_cc',
          img_type: require('@/assets/todoCenter/default/images/cssx.png'),
          isShow: true,
          length: 0,
          flag: 'flow_cc'
        }
      ],
    }
  },
  watch: {
    page_name: {
      deep: true,
      handler(oldV, newV) {
        if (oldV != newV) {
          this.searchKeyword = null;
          if (this.isPage('appall')) this.searchKeyword = this.$store.getters.getState.appQuery.seq;
          if (newV == 'todo' && oldV != 'todo') {
            sessionStorage.removeItem('seq_todo');
          }
        }
      }
    },
    EnterpriseId: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.logoUrl = `${location.origin}/infoplus/file/enterprise/${val}/icon/banner-${this.imgName}`;
        }
      }
    },
    searchStore: {
      immediate: true,
      handler(val) {
        if (val) {
          this.searchValue = val
        }
      }
    },
    $route: {
      immediate: true,
      handler(val) {
        //从三个点来或者直接点服务中心进来
        if (val.params.type == 'tag' || val.query.from == 'other') {
          this.searchValue = ''
          this.$store.commit('setvalue', '')
        }
      }
    }
  },
  computed: {
    userName() {
      return this.$store.getters.getUserInfo.name;
    },
    todoLength() {
      return this.$store.getters.getDataLength['todo'];
    },
    ...mapGetters("oidcStore", ['oidcUser']),
    searchStore() {
      return this.$store.state.searchValue
    },
    page_name() {
      return this.$route.name;
    },
    todo_num() {
      return this.$store.getters.getState.dataLength.todo;
    },
    chooseYear() {
      let year = new Date().getFullYear();
      let last1 = year - 2, last2 = year - 1;
      return [year, last1, last2];
    },
    EnterpriseId() {
      if (this.$store.getters.getUserInfo.enterprise) {
        return this.$store.getters.getUserInfo.enterprise.id;
      } else {
        return '';
      }
    }
  },
  methods: {
    ...mapActions("oidcStore", ['signOutOidc']),
    onSearch() {
      var val = this.searchKeyword;
      if (!this.isPage('todo') && !this.isPage('apps') && !this.isPage('serviceC') && !this.isPage('favorite')) {
        this.$store.dispatch('SearchQ', {key: this.$route.name, property: 'keyword', val});
      }
      if (this.isPage('apps') || this.isPage('appall')) {
        val = val ? val : 'all';
        this.$store.dispatch('updateQuery', {seq: val});
        if (this.isPage('apps')) {
          this.$store.commit('setvalue', this.searchKeyword)
          this.toSearch()
          this.$router.push({name: 'serviceC'})
        }
      }
      if (this.isPage('todo')) {
        sessionStorage.setItem('seq_todo', val);
        this.reload();
      }
      if (this.isPage('favorite')) {
        sessionStorage.setItem('seq_fav', val);
        this.reload();
      }
    },
    toSearch(indexSearch) {
      if (indexSearch) {
        this.$store.commit('setvalue', indexSearch)
      }
      let keyword = indexSearch;
      keyword = keyword == '' ? 'all' : keyword;
      this.$store.dispatch("updateQuery", {seq: keyword});
    },
    changeNowYear(year) {
      this.nowChooseYear = year;
      let start = this.getSeconds(`${year}-01-01`) / 1000;
      let end = this.getSeconds(`${year}-12-31`) / 1000;
      this.$store.dispatch('AddQ', {dataName: this.$route.name, property: 'timestamps', val: `${start}-${end}`});
      this.visi_date = false;
    }
  }
};
</script>
<style lang="less" scoped>
.ant-input {
  &::placeholder {
    color: red;
  }
}

.header-top {
  position: relative;

  .header-top-content {
    position: absolute;
    top: 110px;
    z-index: 999;
    left: 25px;

    .header-top-name {
      color: #fff;
      font-size: 18px;
    }

    .header-top-line {
      width: 20px;
      height: 4px;
      background: #fff;
      display: block;
      margin-top: 12px;
    }
  }

  //自定义渐变蒙层
  .mask_div {
    background: linear-gradient(to right, var(--nowColor), transparent);
    width: 100%;
    height: 180px;
    z-index: 999;
    position: absolute;
    top: 0;
  }

  .header-child {
    width: 100%;
    padding: 13px 0px;
    text-align: center;
    position: fixed;
    top: 0;
    height: 55px;
    background-color: rgb(4, 85, 146);
    z-index: 999;

    .chooseYear {
      color: #fff;
      line-height: 29px;
      border-bottom: 2px dotted #fff;
    }

    .chooseName {
      display: block;
      color: var(--nowColor);
      text-align: center;
      font-size: 13px;
      line-height: 25px;
    }

    .userName {
      font-size: 12px;
      color: white;
      margin-left: 5px;
      line-height: 30px;
    }

    .leftIcon {
      font-size: 16px;
      color: white;
      line-height: 32px;
      margin-right: 10px;
    }
  }

  .header-chil {
    width: 100%;
    padding: 0px 0px;
    text-align: center;
    //position: absolute;
    top: 48px;
    background-color: rgb(4, 85, 146);
    z-index: 999;

    .chooseYear {
      color: #fff;
      line-height: 29px;
      border-bottom: 2px dotted #fff;
    }

    .chooseName {
      display: block;
      color: var(--nowColor);
      text-align: center;
      font-size: 13px;
      line-height: 25px;
    }

    .userName {
      font-size: 12px;
      color: white;
      margin-left: 5px;
      line-height: 30px;
    }

    .leftIcon {
      font-size: 16px;
      color: white;
      line-height: 32px;
      margin-right: 10px;
    }
  }
}

.badge-div {
  position: absolute;
  top: 4px;
}

.header-child-addstyle {
  background: var(--nowColor) !important;
}

a {
  text-decoration: underline;
}

.nav {
  display: flex;
  justify-content: center;
  margin-bottom: 0;

  li {
    width: 33.3333333%;
    text-align: center;
    margin: 10px 0px 0 0;
    position: relative;

    &.active {
      border-bottom: 5px solid var(--yellow);
    }

    i {
      color: var(--write);
      font-size: 30px;
      margin-bottom: 10px;
    }

    .title {
      width: 85%;
      font-size: 14px;
      margin: 0 auto;
      font-weight: bold;
      color: white;
      letter-spacing: 1px;
      margin-bottom: 12px;
    }
  }
}

.nums {
  position: absolute;
  top: 0;
  color: var(--write);
  background: var(--yellow);
  border-radius: 3px;
  font-size: 12px;
  padding: 0 5px;
}

.active {
  border-bottom: 4px solid #d5d525;
}

.activee a {
  color: var(--nowColor) !important;
}

a {
  text-decoration: none;
}

.bgcImg {
  width: 100%;
  height: 180px;
}

.img-ul-tip {
  width: 70%;
  position: absolute;
  top: calc((100% + 50px) / 2);
  margin-left: 15%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  li {
    color: #fff;
    padding: 3px 20px;
    background: var(--nowColor);
  }
}

.header-top {
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/layout/nav.vue